{
  "it": {
    "select": {
      "actions": {
        "clear": "Svuota",
        "filterProject": "Filtra per progetto",
        "filterUnit": "Filtra per unità",
        "noResults": "Nessun risultato",
        "noResultsFor": "Nessun risultato per {search}",
        "reset": "Reimposta",
        "selectCategory": "Selezioni una categoria",
        "selectUnit": "Selezioni un'unità",
        "setToday": "Oggi",
        "startTyping": "Inizi a digitare per cercare"
      },
      "groups": {
        "customers": "Clienti",
        "employees": "Membri del team"
      },
      "labels": {
        "allUnits": "Tutte le unità",
        "contact": "Contatto",
        "without": "Senza",
        "withoutContact": "Senza persona di contatto"
      },
      "placeholders": {
        "contact": "Cerchi una persona, oppure scelga 'senza'..."
      }
    }
  }
}
